(() => {
  const grid = document.querySelector('[data-collection-grid][data-category-query]');
  const params = new URLSearchParams(location.search);
  if (!grid || !grid.dataset.categoryQuery || params.get('catalog') === 'local' || location.pathname.includes('/origin-')) return;
  // Shopify facets only describe saved products; never bypass a customer's active filters.
  if ([...params.keys()].some(key => key.startsWith('filter.')) || params.has('sort_by')) return;
  const section = document.createElement('section');
  section.className = 'salibay-market-feed';
  section.innerHTML = '<h2>More international products</h2><p role="status" data-category-status></p><div class="salibay-product-grid" data-category-grid></div><button type="button" class="btn-secondary" data-category-more>Load more products</button>';
  grid.after(section);
  const target = section.querySelector('[data-category-grid]');
  const status = section.querySelector('[data-category-status]');
  const more = section.querySelector('[data-category-more]');
  const products = new Map();
  const seen = new Set([...grid.querySelectorAll('[data-salibay-public-id]')].map(card => card.dataset.salibayPublicId));
  const seenTitles = new Set([...grid.querySelectorAll('.product-title')].map(node => node.textContent.toLowerCase().replace(/\s+/g, ' ').trim()));
  const query = grid.dataset.categoryQuery;
  const key = `salibay:category:v1:${grid.dataset.collectionHandle}`;
  const escape = value => String(value || '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  let next = 1;
  let busy = false;
  let failed = false;
  function render(payload) {
    for (const product of [payload.recommendedProduct, ...(payload.otherOptions || [])].filter(Boolean)) {
      const titleKey = String(product.title || '').toLowerCase().replace(/\s+/g, ' ').trim();
      if (product.routeType === 'local' || product.ribbonLabel === 'Local Ready' || seen.has(product.publicId) || seenTitles.has(titleKey)) continue;
      if (!product.publicId || !product.title || !Number.isFinite(product.price) || product.price <= 0 || !/^(https:\/\/|\/apps\/salibay-search\/image\/)/.test(product.imageUrl || '')) continue;
      seen.add(product.publicId); seenTitles.add(titleKey); products.set(product.publicId, product);
      const card = window.SalibayProductCards.create(product,{query,page:payload.pagination?.page || next || 1});
      card.classList.add('category-product-card');
      card.dataset.categoryProduct=product.publicId;
      target.append(card);
    }
    next = payload.pagination?.hasMore ? payload.pagination.nextPage : null;
    more.hidden = !next;
    status.textContent = products.size ? `${products.size} global products loaded. Delivery and any additional charges are calculated at checkout.` : 'No additional global products are available for this collection right now.';
  }
  async function load() {
    if (busy || !next) return;
    busy = true; failed = false; more.disabled = true; more.textContent = 'Loading global products...';
    section.setAttribute('aria-busy', 'true'); status.textContent = 'Finding global products for this collection...';
    const page = next;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 45000);
    try {
      const response = await fetch(`/apps/salibay-search/search?${new URLSearchParams({q:query, page:String(page)})}`, {signal:controller.signal, headers:{Accept:'application/json'}});
      const payload = await response.json();
      if (!response.ok || payload.error) throw new Error('Unavailable');
      if (payload.pagination?.hasMore && Number(payload.pagination.nextPage) <= Number(page)) throw new Error('Invalid pagination');
      render(payload);
      if (page === 1) try { sessionStorage.setItem(key, JSON.stringify({at:Date.now(), payload})); } catch (_) {}
    } catch (_) {
      failed = true; more.hidden = false;
      status.textContent = 'More products could not load. You can still shop the products above. Please try again.';
    } finally {
      clearTimeout(timer); busy = false; more.disabled = false;
      more.textContent = failed ? 'Retry global products' : 'Load more global products';
      section.removeAttribute('aria-busy');
      if (!failed && next) { observer?.unobserve(more); observer?.observe(more); }
    }
  }
  more.addEventListener('click', load);
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    if (entries.some(entry => entry.isIntersecting) && !failed) load();
  }, {rootMargin:'400px'}) : null;
  try {
    const cached = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (cached && Date.now() - cached.at < 1800000) render(cached.payload);
  } catch (_) {}
  observer?.observe(more);
  if (!products.size) load();
})();
